import { render, staticRenderFns } from "./inventoryCreatePage.vue?vue&type=template&id=294bb06c&"
import script from "./inventoryCreatePage.vue?vue&type=script&lang=ts&"
export * from "./inventoryCreatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports